export const qs = (href = window.location.href, ignoreHash = false) => {
  const result = {};
  let param = null;
  const reg = /[?&](.*?)=([^&#]*)/g;
  if (ignoreHash) {
    href = href.replace(/#.*?$/, "");
  }

  param = reg.exec(href);
  while (param) {
    // 上面已经decode过，不需要重复decode，过度decode会导致其它问题
    // result[param[1]] = param[2];
    try {
      result[param[1]] = decodeURIComponent(param[2]);
    } catch (e) {
      try {
        result[param[1]] = unescape(param[2]);
      } catch (escapeErr) {
        // eslint-disable-next-line prefer-destructuring
        result[param[1]] = param[2];
      }
      // result[param[1]] = `Decode Error: ${param[2]}`;
    }
    param = reg.exec(href);
  }
  return result;
};

export const QS = qs();
const querySea = QS.isSea && process.env.NODE_ENV !== "production";
export const IS_SEA = querySea || process.env.VUE_APP_ENV.includes("sea");

export const delay = (ms) => new Promise((resolve) => {
  setTimeout(() => resolve(), ms);
});
